import { DotsVerticalIcon, Loading01Icon } from '@langchain/untitled-ui-icons';
import { PopoverPortal } from '@radix-ui/react-popover';

import { Popover, PopoverContent, PopoverTrigger } from '@/components/Popover';

export function MoreActionsButton({
  isLoading,
  onDelete,
}: {
  isLoading: boolean;
  onDelete: () => void;
}) {
  return (
    <td className="sticky right-0 border-b border-secondary bg-background">
      <Popover>
        <PopoverTrigger>
          <div className="rounded-md p-1 text-quaternary hover:bg-tertiary">
            <DotsVerticalIcon className="my-auto h-4 w-4" />
          </div>
        </PopoverTrigger>
        <PopoverPortal>
          <PopoverContent
            sideOffset={5}
            align="end"
            className="relative z-[999] w-fit p-2"
          >
            <button
              type="button"
              onClick={onDelete}
              className="flex items-center gap-2 rounded-md px-2 py-1 text-sm font-medium text-secondary hover:bg-secondary"
            >
              {isLoading ? (
                <Loading01Icon className="h-4 w-4 animate-spin" />
              ) : (
                'Delete row'
              )}
            </button>
          </PopoverContent>
        </PopoverPortal>
      </Popover>
    </td>
  );
}
